import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { LoadingService } from './services/loading.service';
import { distinctUntilChanged } from 'rxjs/operators';
import { AuthService } from './services/auth.service';
import { SharedService } from './services/shared.service';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './common/header/header.component';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent]
})
export class AppComponent implements OnInit {
  private loading = inject(LoadingService);
  private cdr = inject(ChangeDetectorRef);
  private authService = inject(AuthService);
  private sharedService = inject(SharedService);

  title = 'PVT';
  isShow = false;
  loader = false;
  

  ngOnInit(): void {
    this.sharedService.HandleBrowserRefreshRedirect();

    this.loading.isLoggedIn$.
      pipe(distinctUntilChanged())
      .subscribe(
        Res => {
          this.loader = Res;
          this.cdr.detectChanges();
        }
      )

    
    this.authService.isLoggedIn$.
      pipe(distinctUntilChanged())
      .subscribe(
        Res => {
          this.isShow = Res;
          this.cdr.detectChanges();
        }
      )
  }
}
